// import { httpRegisterToOur } from "../api/apiCalls";
import Message from "./Message";
import { createWsClient, leaveWsChannel, registerWSClient } from "./websockets";

type eventType = "close" | "error" | "message" | "open";

type callbackItem = { ev: eventType; cb: Function };

// const websocketURL = 'ws://10.0.2.2:5002/';

export default class WebsocketEventer {
  private listners: callbackItem[] = [];
  private unSentQueue: Message[] = [];
  private websocketURL: string;
  websocketClient: undefined | WebSocket;

  constructor(websocketURL?: string) {
    if (!websocketURL) {
      this.websocketURL = "";
    } else {
      this.websocketClient = createWsClient(websocketURL, undefined);
      this.registerEventsToClient();
      this.websocketURL = websocketURL;
    }
  }

  private registerEventsToClient() {
    if (!this.websocketClient) return;
    this.websocketClient.onmessage = (msg) => {
      this.listners.forEach((val) => {
        if (val.ev === "message") {
          const cb = val.cb;
          cb(msg);
        }
      });
    };
    this.websocketClient.onerror = (error) => {
      console.error(error);
      this.listners.forEach((val) => {
        if (val.ev === "error") {
          const cb = val.cb;
          cb(error);
        }
      });
    };
    this.websocketClient.onopen = () => {
      // this.websocketClient.send("{}");
      this.listners.forEach((val) => {
        if (val.ev === "open") {
          const cb = val.cb;
          cb();
        }
      });
      if (this.unSentQueue.length > 0) {
        this.unSentQueue.forEach(
          (msg) =>
            this.websocketClient &&
            this.websocketClient.send(JSON.stringify(msg))
        );
        this.unSentQueue = [];
      }
    };
    this.websocketClient.onclose = (event) => {
      this.listners.forEach((val) => {
        if (val.ev === "close") {
          const cb = val.cb;
          cb(event);
        }
      });
    };
  }
  getSocketUrl() {
    return this.websocketURL;
  }
  connectTo(websocketURL: string) {
    console.debug("Connectiong to " + websocketURL);
    this.websocketClient = createWsClient(websocketURL, undefined);
    this.registerEventsToClient();
    this.websocketURL = websocketURL;
  }
  close(code?: number, reason?: string) {
    if (!this.websocketClient) return;

    console.debug("Socket is closed");
    this.websocketClient.close(code, reason);
  }

  restart(code?: number, reason?: string) {
    if (this.isOpened()) {
      this.close(code, reason);
    }
    this.websocketClient = createWsClient(this.websocketURL, undefined);
    this.registerEventsToClient();
  }

  on(eventName: eventType, callback: Function) {
    if (eventName === "open" && this.isOpened()) {
      (callback as () => void)();
    }
    this.listners.push({
      ev: eventName,
      cb: callback,
    });
  }

  remove(eventName: eventType, callback: Function) {
    for (let i = 0; i < this.listners.length; i++) {
      if (
        this.listners[i].cb === callback &&
        this.listners[i].ev === eventName
      ) {
        this.listners.splice(i, 1);
        i = 0;
      }
    }
  }

  send(msg: Message) {
    if (!this.websocketClient) return;

    if (this.isOpened()) this.websocketClient.send(JSON.stringify(msg));
    else this.unSentQueue.push(msg);
    // httpRegisterToOur(msg);
  }

  registerToChannel(event: string, userid: string) {
    registerWSClient(this, event, userid);
  }

  async unregisterFromChannel(event: string, userid: string) {
    leaveWsChannel(this, event, userid);
  }

  isOpened() {
    return this.websocketClient?.readyState === this.websocketClient?.OPEN;
  }
}
